export const postAcombaPurchaseOrder = async ({ ip, port, payload }) => {
  if (!payload || typeof payload !== "object" || Array.isArray(payload) || !Array.isArray(payload.lines)) {
    throw new Error("POIMPORT_POST must return a valid JSON object with a lines array.");
  }
  const host = String(ip || "").trim();
  const sdkPort = String(port || "").trim();

  if (!host || !sdkPort) {
    throw new Error("Acomba SDK IP or port is missing.");
  }

  const hasProtocol =
    host.toLowerCase().startsWith("http://") || host.toLowerCase().startsWith("https://");
  let baseUrl = hasProtocol ? host : `http://${host}`;
  while (baseUrl.endsWith("/")) baseUrl = baseUrl.slice(0, -1);

  const url = `${baseUrl}:${sdkPort}/api/acomba/purchase-orders`;
  let response;

  try {
    response = await fetch(url, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    });
  } catch (error) {
    throw new Error(`Could not connect to Acomba SDK at ${url}: ${error.message}`);
  }

  const responseText = await response.text();
  let responseData = responseText;

  if (responseText) {
    try {
      responseData = JSON.parse(responseText);
    } catch (error) {
      // Keep a non-JSON response available for display.
    }
  }

  if (!response.ok) {
    const message =
      responseData?.message || responseText || `Acomba SDK request failed (${response.status})`;
    const error = new Error(message);
    error.responseData = responseData;
    throw error;
  }


  return responseData;
};
